import type { UpdateEnrollmentProgress200Course } from './updateEnrollmentProgress200Course';

/**
 * 수강 정보 응답
 */
export type UpdateEnrollmentProgress200 = {
  /** 수강 중인 강좌 요약 정보 */
  course: UpdateEnrollmentProgress200Course;
  /** 수강 시작 시간 */
  enrolledAt: string;
  /** 수강 ID */
  enrollmentId: string;
  /**
   * 학습 진도율 (0-100)
   * @minimum 0
   * @maximum 100
   */
  progressRate: number;
};
